import Vue from 'vue'
// const AudioVisual = require('vue-audio-visual')

// import AVPlugin from 'vue-audio-visual'
import AVPlugin from '@/modules/vue-audio-visual'

Vue.use(AVPlugin)
